import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function CashoutWarningBanner({ onPaymentMethodUpdate }) {
  const { t } = useTranslation(null, { useSuspense: false });
  return (
    <div className="cashout-status-banner cashout-status-banner--warning" role="alert">
      <span
        className="cashout-status-banner__icon phoenix-icon phoenix-icon-warning"
        aria-hidden="true"
      />
      <div className="cashout-status-banner__body">
        <p className="cashout-status-banner__title">{t('cashout-failed-banner-title')}</p>
        <p className="cashout-status-banner__text">{t('cashout-failed-banner-message')}</p>
        {onPaymentMethodUpdate && (
          <button
            type="button"
            className="cashout-status-banner__action"
            onClick={onPaymentMethodUpdate}
          >
            {t('cashout_update_payment_method')}
          </button>
        )}
      </div>
    </div>
  );
}

CashoutWarningBanner.propTypes = {
  onPaymentMethodUpdate: PropTypes.func.isRequired,
};
